export default __webpack_public_path__ + "static/allency-support-areas-marketing-774c287eb0b90ee1305e70720580f127.svg";